import * as v from 'valibot';

import { createValibotSchema, type JSchema } from '@/modules/validators';

import type { AddressFormValues } from '../../../models';

type AddressFormField = keyof AddressFormValues;

type FieldError = {
  message?: string;
};

type FormErrorMap = Partial<Record<AddressFormField, FieldError[]>>;

type ApiErrorMap = Partial<
  Record<'address1' | 'address2' | 'city' | 'countryCode' | 'name' | 'postalCode' | 'stateCode', FieldError[]>
>;

export function createAddressFormValidator(apiJsonSchema: JSchema) {
  const apiValibotSchema = createValibotSchema(apiJsonSchema);

  return v.pipe(
    v.custom<AddressFormValues>(() => true),
    v.transform((formValues: AddressFormValues) => ({
      address1: formValues.address1,
      address2: formValues.address2,
      categoryKey: 1,
      city: formValues.city,
      countryCode: formValues.country?.id ?? '',
      customerKey: 1,
      name: formValues.name,
      postalCode: formValues.postalCode,
      stateCode: formValues.state?.id ?? '',
    })),
    apiValibotSchema,
  );
}

export function mapApiErrorsToFormFields(errorMap?: ApiErrorMap): FormErrorMap {
  if (!errorMap) {
    return {};
  }

  return {
    address1: errorMap.address1,
    address2: errorMap.address2,
    city: errorMap.city,
    country: errorMap.countryCode,
    name: errorMap.name,
    postalCode: errorMap.postalCode,
    state: errorMap.stateCode,
  };
}
